
namespace Matrix.Indexation {
    export class IndexRorColumns {
        static columnsKey = 'Indexation.IndexRor';
    }
}